<div
    class="cmps-eval-score-alert"
    [cmpsTooltipTrigger]="label | translate"
    placement="top-center"
>
    <svg
        viewBox="0 0 24 24"
        width="24"
        height="24"
    >
        <circle
            r="9"
            cy="12"
            cx="12"
            fill="#fff"
        ></circle>
    </svg>
    <cmps-icon svgIcon="alert-circle"></cmps-icon>
</div>
